import { createSelector } from 'reselect';

const selectEnvironments = (state: any) => state.environments;


export const selectEnvironmentsCurrentItem = createSelector([selectEnvironments], (environments) => environments.current);

export const selectEnvironmentsListItems = createSelector([selectEnvironments], (environments) => environments.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectEnvironmentsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEnvironmentsQueryItems = createSelector([selectEnvironments], (environments) => environments.query);

export const selectEnvironmentsCreatedItem = createSelector([selectEnvironments], (environments) => environments.create);

export const selectEnvironmentsUpdatedItem = createSelector([selectEnvironments], (environments) => environments.update);

export const selectEnvironmentsReadItem = createSelector([selectEnvironments], (environments) => environments.read);

export const selectEnvironmentsDeletedItem = createSelector([selectEnvironments], (environments) => environments.delete);

export const selectEnvironmentsSearchedItems = createSelector([selectEnvironments], (environments) => environments.search);

export const selectEnvironmentsItemsCount = createSelector([selectEnvironments], (environments) => environments.count);

export const selectEnvironmentsItemsFilter = createSelector([selectEnvironments], (environments) => environments.filter);